"use client";

import { Tabs } from "@/components/ui/tabs";
import { useSelectContentEvent } from "@/features/analytics/hooks/use-select-content-event";
import { useRouter } from "@/i18n/navigation";
import { useSearchParams } from "next/navigation";

type ListingListTabsProps = {
  defaultTab: string;
  children: React.ReactNode;
};

export const ListingListTabs = ({
  children,
  defaultTab,
}: ListingListTabsProps) => {
  const searchParams = useSearchParams();
  const { replace } = useRouter();
  const { sendSelectContentEvent } = useSelectContentEvent();
  const handleTabChange = (value: string) => {
    const params = new URLSearchParams(searchParams);
    params.delete("page");
    params.delete("numberOfMeals");
    params.delete("preset");
    params.delete("configuration");
    sendSelectContentEvent({
      content_type: "segmentedControl",
      link_text: value === "diets" ? "diety" : "catering",
    })
    const query = Object.fromEntries(params);
    replace(
      value === "diets"
        ? { pathname: "/diets", query }
        : { pathname: "/caterings/[[...slug]]", params: { slug: [] }, query }
    );
  };

  return (
    <Tabs
      defaultValue={defaultTab}
      className="w-full"
      onValueChange={handleTabChange}
    >
      {children}
    </Tabs>
  );
};
